import { useLanguage } from '../i18n';
import { Crown, ArrowUpRight, Sparkles } from 'lucide-react';

interface UpgradePromptProps {
  variant: 'limit' | 'locked' | 'blocked';
  sectionName?: string;
  onUpgrade: () => void;
}

export default function UpgradePrompt({ variant, sectionName, onUpgrade }: UpgradePromptProps) {
  const { t } = useLanguage();
  const u = t.upgrade;

  const title =
    variant === 'limit' ? u.limitTitle : variant === 'blocked' ? u.blockedTitle : u.lockedTitle;
  const body =
    variant === 'limit'
      ? u.limitBody
      : variant === 'blocked'
      ? u.blockedBody(sectionName || '')
      : u.lockedBody(sectionName || '');
  const cta = variant === 'limit' ? u.limitCta : u.lockedCta;

  return (
    <div className="relative overflow-hidden bg-white border border-cloud p-8 text-center mb-6 animate-fade-in">
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="gradient-orb gradient-orb-red w-72 h-72 -top-20 -right-20"
          style={{ animationDuration: '10s', animationDelay: '0s' }}
        />
        <div
          className="gradient-orb gradient-orb-blue w-64 h-64 -bottom-16 -left-16 opacity-70"
          style={{ animationDuration: '13s', animationDelay: '-4s' }}
        />
        <div
          className="gradient-orb gradient-orb-red w-48 h-48 top-1/2 left-1/3 opacity-40"
          style={{ animationDuration: '15s', animationDelay: '-8s' }}
        />
      </div>

      <div className="relative z-10">
        <div className="w-14 h-14 bg-red-50 border border-red-100 flex items-center justify-center mx-auto mb-4">
          <Crown size={28} className="text-red-500" />
        </div>

        <h3 className="text-xl font-bold text-ink mb-2">{title}</h3>
        <p className="text-slate max-w-md mx-auto mb-6">{body}</p>

        <button
          onClick={onUpgrade}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-red-500 hover:bg-red-600 text-white font-semibold transition-colors"
        >
          <Sparkles size={18} />
          {cta}
          <ArrowUpRight size={18} />
        </button>
      </div>
    </div>
  );
}
